import Vue from 'vue'
import {
    Toast
} from 'vant';
Vue.use(Toast);

// 统一维护一些提示组件，避免全局修改
export default {
    count: 0,
    // 加载遮罩
    loading(message) {
        // 计数器加1
        this.count++;
        // console.log('loading，请求总数：', this.count, Toast);
        // 有赞2.10.3版本一个很奇怪的bug，会重复创建多份Toast对象，导致  Toast.clear(true) 也无法关闭，这里只能做个判断避免创建多份Toast对象
        if (this.count < 2) {
            Toast.loading({
                duration: 0,
                message: message,
                // 禁止背景点击
                forbidClick: true,
                loadingType: 'spinner'
            });
        }
    },
    // 提示
    show(params) {
        Toast(params)
    },
    // 清除提示
    clear() {
        var me = this;
        // console.log('loadingend，请求总数：', me.count);
        if (me.count > 1) {
            // 当计数器大于1时减1
            me.count--;
        } else {
            // 当计数器等于1时隐藏遮罩
            // 计数器归0
            me.count = 0;
            Toast.clear(true);
        }
    },
    // 成功提示
    success(params) {
        Toast.success(params);
    },
    // 失败提示
    fail(params) {
        Toast.fail(params);
    }
}